export default __webpack_public_path__ + "static/experienceImg1-b6d407415a00e34b429e7890e7849567.webp";